// extracted by mini-css-extract-plugin
export var icons = "style-module--icons--c2d97";
export var sns = "style-module--sns--c8a71";
export var text = "style-module--text--82b2d";